var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navigation',{on:{"on-open-menu":_vm.openMenu,"on-close-menu":_vm.closeMenu}}),_c('main',{class:_vm.isClosedMenu ? 'close-menu' : '',attrs:{"id":"page-wrap"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }